module.exports = __webpack_public_path__ + "static/media/NewCycles.0c119cf7.svg";